import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'
import * as moment from 'moment-timezone'

const DATE_FORMAT = 'DD/MM/YYYY'

// Connects to data-controller="buscar-reportes"
export default class extends Controller {
  static targets = ["desde", "hasta", "obraSocial", "hoja", "count", "selectedList", "imprimirBtn", "imprimirTodoBtn"]
  static values = {
    url: String,
    registro: Number,
    processingReport: Boolean,
    typesCount: Number
  }

  connect() {
    this.processingReportValue = Boolean(this.data.get("processingReport"));
    this.updateHojaSummary();
    this.updateImprimirButtonState();

    this.element.addEventListener('change', (e) => {
      if (e.target.name === 'hoja[]' || e.target.id === 'select_all_hojas') {
        this.updateHojaSummary();
      }
    });
  }

  updateImprimirButtonState() {
    if (!this.hasImprimirBtnTarget) return

    this.imprimirBtnTarget.classList.toggle('disabled', this.processingReportValue)
  }

  resolveDateValue(target) {
    const raw = target?.value?.trim()
    const parsed = raw ? moment(raw, DATE_FORMAT, true) : null

    return (parsed && parsed.isValid()) ? raw : null
  }

  disableActionButtons() {
    this.processingReportValue = true
    if (this.hasImprimirBtnTarget) this.imprimirBtnTarget.classList.add('disabled')
    if (this.hasImprimirTodoBtnTarget) this.imprimirTodoBtnTarget.classList.add('disabled')
  }

  updateHojaSummary() {
    const hojas = (this.hojaTargets || []).filter(cb => cb.checked).map(cb => cb.value)
    const count = hojas.length

    if (this.hasCountTarget) this.countTarget.textContent = count

    if (this.hasSelectedListTarget) {
      if (count === 0) this.selectedListTarget.textContent = 'Todas'
      else {
        const max = 5
        const shown = hojas.slice(0, max).join(', ')
        this.selectedListTarget.textContent = hojas.length > max ? `${shown}, ...` : shown
      }
    }
  }

  imprimir(event) {
    event.preventDefault()

    if (this.processingReportValue) return

    const desde = this.resolveDateValue(this.desdeTarget)
    const hasta = this.resolveDateValue(this.hastaTarget)

    const hojas = (this.hojaTargets || []).filter(cb => cb.checked).map(cb => cb.value)

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("registro", this.registroValue)
    if (desde) url.searchParams.set("start_date", desde)
    if (hasta) url.searchParams.set("end_date", hasta)

    if (hojas.length > 0) {
      hojas.forEach(h => url.searchParams.append("hoja[]", h))

      if (this.hasTypesCountValue && hojas.length === this.typesCountValue) {
        url.searchParams.set('include_archivos', '1')
      }
    }

    this.disableActionButtons()
    get(url.pathname + url.search, { responseKind: 'turbo-stream' })
  }

  imprimirTodo(event) {
    event.preventDefault()

    if (this.processingReportValue) return

    this.disableActionButtons()
    get(event.currentTarget.getAttribute('href'), { responseKind: 'turbo-stream' })
  }

  imprimirLote(e) {
    e.preventDefault()
    const obraSocialValue = this.obraSocialTarget.value;

    get(`${this.urlValue}?start_date=${this.desdeTarget.value}&end_date=${this.hastaTarget.value}&obra_social=${obraSocialValue}`, { responseKind: 'turbo-stream' })
  }
}
